export default function (className, width = 48, height = 48) {
	return `<svg ${className ? 'class="' + className + '" ' : ''}xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
    <g stroke="none" stroke-width="0" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <polyline id="Path-4" stroke="currentColor" stroke-width="6" points="8 8 14.4100233 14.4100233 40 40"></polyline>
        <polyline id="Path-4" stroke="currentColor" stroke-width="6" transform="translate(24.000000, 24.000000) scale(-1, 1) translate(-24.000000, -24.000000) " points="8 8 14.4100233 14.4100233 40 40"></polyline>
    </g>
</svg>`;
}